var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-xs-12 trivia-heading" }, [
    _c(
      "div",
      { staticClass: "trivia-complete-card" },
      [
        _c("trivia-empty-state", { staticClass: "trivia-complete-icon" }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.$t("TRIVIA_COMPLETE_TITLE")))]),
        _vm._v(" "),
        _c("p", { staticClass: "trivia-complete-text" }, [
          _vm._v(_vm._s(_vm.$t("TRIVIA_COMPLETE_TEXT"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              staticClass: "btn primary-btn",
              on: {
                click: function ($event) {
                  return _vm.$router.push({
                    name: "categoryDashboard",
                    params: { category: _vm.$route.params.category },
                  })
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("TRIVIA_COMPLETE_BACK_BUTTON")))]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }